import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const RegisterPage = Loadable(lazy(()=> import('../pages/auth/Register')));
// export const DashboardPage = Loadable(lazy(()=> import('../pages/dashboard/DashboardPage')));
export const PasswordResetPage = Loadable(lazy(()=> import('../pages/auth/ResetPassword')));
export const PasswordResetSentPage = Loadable(lazy(()=> import('../pages/auth/ResetPasswordSent')));
export const EmailLinkPage = Loadable(lazy(()=> import ('../pages/auth/EmailLink')));
export const EmailVerifiedPage = Loadable(lazy(()=> import("../pages/auth/EmailVerified")));
export const UsersViewPage = Loadable(lazy(()=> import ('../pages/users/UsersViewPage')));
export const JobsViewPage = Loadable(lazy(()=> import('../pages/jobs/JobsViewPage')));
export const HvacUnitsPage = Loadable(lazy(()=> import('../pages/hvac/HvacUnits')));
export const BusinessesViewPage = Loadable(lazy(()=> import('../pages/businesses/BusinessesViewPage')));
export const JobsInfoPage = Loadable(lazy(()=>import ('../pages/jobs/JobsInfoPage')));
export const HvacInfoPage = Loadable(lazy(()=> import( '../pages/hvac/HvacInfoPage')));
export const SettingsPage = Loadable(lazy(()=>import("../pages/settings/SettingsPage")));
export const PrivacyPolicyPage = Loadable(lazy(()=> import("../pages/privacy/PrivacyPolicyPage")));
export const JobsAssignPage = Loadable(lazy(()=> import("../pages/jobs/JobsAssignPage")));
export const RequestAccountDeletionPage = Loadable(lazy(()=> import("../pages/auth/RequestAccountDeletion")));
export const VerifyRequestAccountDeletionPage = Loadable(lazy(()=> import("../pages/auth/VerifyRequestAccountDeletion")));